import { MarkovState } from "server/models"

import { OrderType } from "client/utils"
import { MarkovStateFilters } from "client/store"


export interface MarkovGroupStateList { [groupId: number]: number[]}

export interface MarkovGroupStateState {
    groupStateList: MarkovGroupStateList

    assignedStates: {
        stateIds: readonly number[]
        sortColumn: keyof MarkovState
        sortOrder: OrderType
        filters: MarkovStateFilters
    }
    notAssignedStates: {
        stateIds: readonly number[]
        sortColumn: keyof MarkovState
        sortOrder: OrderType
        filters: MarkovStateFilters
        selected: readonly number[]
    }

    reloadGroupStateList: boolean
}

export const MARKOV_GROUP_STATE_LIST = "MARKOV_GROUP_STATE_LIST"

export const ASSIGNED_MARKOV_GROUP_STATE_IDS = "ASSIGNED_MARKOV_GROUP_STATE_IDS"
export const ASSIGNED_MARKOV_GROUP_STATE_SORT = "ASSIGNED_MARKOV_GROUP_STATE_SORT"
export const ASSIGNED_MARKOV_GROUP_STATE_FILTERS = "ASSIGNED_MARKOV_GROUP_STATE_FILTERS"

export const NOT_ASSIGNED_MARKOV_GROUP_STATE_IDS = "NOT_ASSIGNED_MARKOV_GROUP_STATE_IDS"
export const NOT_ASSIGNED_MARKOV_GROUP_STATE_SORT = "NOT_ASSIGNED_MARKOV_GROUP_STATE_SORT"
export const NOT_ASSIGNED_MARKOV_GROUP_STATE_FILTERS = "NOT_ASSIGNED_MARKOV_GROUP_STATE_FILTERS"
export const NOT_ASSIGNED_MARKOV_GROUP_STATE_SELECTED = "NOT_ASSIGNED_MARKOV_GROUP_STATE_SELECTED"

export const MARKOV_GROUP_STATE_RELOAD_LIST = "MARKOV_GROUP_STATE_RELOAD_LIST"
